export const MCP_ENDPOINT =
  "https://public-onemap-gateway-hoaiixjtvz.gateway.bedrock-agentcore.ap-southeast-1.amazonaws.com/mcp";

export const AUTH_BASE = "https://www.onemap.gov.sg/api/mcp/auth/v1";

export const ONEMAP_REGISTER_URL = "https://www.onemap.gov.sg/apidocs/register";
export const ONEMAP_REGISTER_CONFIRM_URL =
  "https://www.onemap.gov.sg/apidocs/registerconfirm";

export const REFRESH_CURL = `curl -X POST "${AUTH_BASE}/token/refresh" \\
  -H "Content-Type: application/json" \\
  -d '{"email": "your@email.com", "password": "your-password"}'`;

export const REFRESH_RESPONSE = `// Response
{
  "refresh_token": "eyJjdHkiOiJKV1Q...",
  "expiry_timestamp": 1781279337
}`;

export const ACCESS_CURL = `curl -X POST "${AUTH_BASE}/token" \\
  -H "Content-Type: application/json" \\
  -d '{"email": "your@email.com", "refreshToken": "PASTE_REFRESH_TOKEN_HERE"}'`;

export const ACCESS_RESPONSE = `// Response
{
  "access_token": "eyJraWQiOiJPWWx...",
  "expiry_timestamp": 1778777272
}`;

export const ACCESS_TOKEN_ONE_LINER = `curl -s -X POST "${AUTH_BASE}/token" \\
  -H "Content-Type: application/json" \\
  -d '{"email": "your@email.com", "refreshToken": "PASTE_REFRESH_TOKEN_HERE"}' \\
  | grep -o '"access_token" *: *"[^"]*"' | cut -d'"' -f4`;

export const CLAUDE_CODE_ADD = `claude mcp add --transport http onemap \\
  ${MCP_ENDPOINT} \\
  --header "Authorization: Bearer <access_token>"`;

export const CLAUDE_DESKTOP_CONFIG = `{
  "mcpServers": {
    "onemap": {
      "command": "npx",
      "args": [
        "-y",
        "mcp-remote",
        "${MCP_ENDPOINT}",
        "--header",
        "Authorization:\${AUTH_HEADER}"
      ],
      "env": {
        "AUTH_HEADER": "Bearer <access_token>"
      }
    }
  }
}`;

export const KIRO_CONFIG = `{
  "mcpServers": {
    "onemap": {
      "url": "${MCP_ENDPOINT}",
      "headers": {
        "Authorization": "Bearer <access_token>"
      }
    }
  }
}`;

export const SERVER_ADDRESS_CARD = {
  id: "server-address",
  title: "MCP server address",
  code: MCP_ENDPOINT,
  mode: "plain",
};

export const CONFIG_CARDS = [
  {
    id: "claude-desktop",
    title: "Claude Desktop · Settings → Developer → Edit Config (needs Node.js)",
    code: CLAUDE_DESKTOP_CONFIG,
    mode: "json",
    label: "Claude Desktop config",
  },
  {
    id: "kiro",
    title: "Kiro · .kiro/settings/mcp.json",
    code: KIRO_CONFIG,
    mode: "json",
    label: "Kiro config",
    note: (
      <>
        Use <code>.kiro/settings/mcp.json</code> for this project only, or{" "}
        <code>~/.kiro/settings/mcp.json</code> for every workspace. Kiro expands{" "}
        <code>{"${VAR}"}</code> from your shell environment, so you can
        reference an environment variable in <code>headers</code> instead of
        pasting the token in.
      </>
    ),
  },
];


export const TOOLS_LIST_CURL = `curl --location "${MCP_ENDPOINT}" \\
  --header "Content-Type: application/json" \\
  --header "Accept: application/json, text/event-stream" \\
  --header "Authorization: Bearer <access_token>" \\
  --data '{"jsonrpc": "2.0", "method": "tools/list", "id": 1}'`;

export const CURSOR_CONFIG = `{
  "mcpServers": {
    "onemap": {
      "url": "${MCP_ENDPOINT}",
      "headers": {
        "Authorization": "Bearer <access_token>"
      }
    }
  }
}`;

export const VSCODE_CONFIG = `{
  "servers": {
    "onemap": {
      "type": "http",
      "url": "${MCP_ENDPOINT}",
      "headers": {
        "Authorization": "Bearer <access_token>"
      }
    }
  }
}`;

export const TOOLS_CALL_CURL = `curl --location "${MCP_ENDPOINT}" \\
  --header "Content-Type: application/json" \\
  --header "Accept: application/json, text/event-stream" \\
  --header "Authorization: Bearer <access_token>" \\
  --data '{
    "jsonrpc": "2.0",
    "method": "tools/call",
    "params": {
      "name": "address___search",
      "arguments": {
        "searchVal": "1 North Buona Vista Drive",
        "returnGeom": "Y",
        "getAddrDetails": "Y",
        "pageNum": 1
      }
    },
    "id": 2
  }'`;
